import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { economicalValueChannelSourcesQueryKeys } from './query-keys';

export type TDeleteEconomicalValueChannelSourceParams = {
  id: string;
};

export function deleteEconomicalValueChannelSource({
  id,
}: TDeleteEconomicalValueChannelSourceParams): Promise<unknown> {
  return mediaManagerClient.delete(`/api/v1/economical_value_channel_sources/${id}`);
}

type MutationFn = typeof deleteEconomicalValueChannelSource;

type UseDeleteEconomicalValueChannelSourceParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteEconomicalValueChannelSource({
  config,
}: UseDeleteEconomicalValueChannelSourceParams = {}) {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      const { status } = parseError(error);
      console.error(error);

      if (status === 404) {
        return addErrorNotification(
          'La fuente de valor económico no existe o ya ha sido eliminada'
        );
      }
      if (status === 403) {
        return addErrorNotification(
          'No tienes permisos para eliminar esta fuente de valor económico'
        );
      }
      addErrorNotification('No se ha podido eliminar la fuente de valor económico');
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: economicalValueChannelSourcesQueryKeys.all });
      addSuccessNotification('La fuente de valor económico se ha eliminado correctamente');
    },
    ...config,
    mutationFn: deleteEconomicalValueChannelSource,
  });
}
